import { Rpc } from '../rpc';
import { RpcObservableServer } from '../rpc-observable-server';
import {
    RpcObservableAliveError, RpcObservableAliveKey, RpcObservableAliveRequest, RpcObservableAliveResult
} from './rpc-observable-alive-model';

export class RpcObservableAliveServer
    extends RpcObservableServer<RpcObservableAliveRequest, RpcObservableAliveResult, RpcObservableAliveError> {

    /**
     * Initializes a new instance of the RpcObservableAliveServer class.
     *
     * @param rpc the rpc object.
     */
    constructor(rpc: Rpc) {
        super(rpc, RpcObservableAliveKey.command, RpcObservableAliveKey.version);
    }
}
